
// Função para buscar lista de documentos do backend
export const fetchDocuments = async (setDocumentList, assistant, accessToken) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get_list_documents`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const raw = data.post_list_documents;
        if (!Array.isArray(raw)) {
            console.warn('get_list_documents: resposta sem lista', data);
            setDocumentList([]);
            return;
        }
        const uniqueDocuments = removeDuplicatesAndSortByDate(raw);
        setDocumentList(uniqueDocuments);
    } catch (error) {
        console.error('Error fetching documents:', error);
    }

};

const removeDuplicatesAndSortByDate = (documents) => {
    const uniqueDocs = [];
    const fileNameSet = new Set();

    // Remover duplicados e manter apenas a primeira ocorrência
    documents.forEach(doc => {
        if (!fileNameSet.has(doc.FileName)) {
            fileNameSet.add(doc.FileName);
            uniqueDocs.push(doc);
        }
    });

    // Ordenar os documentos pela data em ordem decrescente
    uniqueDocs.sort((a, b) => new Date(b.Date) - new Date(a.Date));

    return uniqueDocs;
};
